import * as Sentry from '@sentry/gatsby'

import { config } from './src/config/global'

if (config.sentryDSN) {
  Sentry.setTags({
    country: config.country,
    region: config.region,
  })

  Sentry.init({
    dsn: config.sentryDSN,
    release: `dodo-landing-page@${config.version}`,
    environment: config.env,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: config.env === 'production' ? 0.01 : 1,
    beforeSend: event => {
      if (event.level === 'fatal' || event.level === 'error') {
        return event
      }
      return null
    },
  })
}
